import { LogoSelector } from "./components/LogoSelector";
import { PdfGenerator } from "./components/PdfGenerator";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { useI18n } from '@/hooks/useI18n';

interface SendQuoteStep2Props {
    logoChoice: 'own' | 'agency' | null;
    onLogoChoiceChange: (value: 'own' | 'agency') => void;
    hasOwnLogo: boolean;
    hasAgencyLogo: boolean;
    ownLogoUrl?: string | null;
    ownLogoSmallUrl?: string | null;
    agencyLogoUrl?: string | null;
    agencyLogoSmallUrl?: string | null;
    isPdfGenerating: boolean;
    pdfBase64: string | null;
    pdfFilename: string | null;
    pdfError: string | null;
    onGeneratePdf: () => void;
    onPreviewPdf: () => void;
    includePdf: boolean;
    onIncludePdfChange: (value: boolean) => void;
}

export const SendQuoteStep2 = ({
    logoChoice,
    onLogoChoiceChange,
    hasOwnLogo,
    hasAgencyLogo,
    ownLogoUrl,
    ownLogoSmallUrl,
    agencyLogoUrl,
    agencyLogoSmallUrl,
    isPdfGenerating,
    pdfBase64,
    pdfFilename,
    pdfError,
    onGeneratePdf,
    onPreviewPdf,
    includePdf,
    onIncludePdfChange
}: SendQuoteStep2Props) => {
    const { t } = useI18n();
    const hasLogoSelected = logoChoice !== null;

    return (
        <div className="space-y-6">
            <LogoSelector
                logoChoice={logoChoice}
                onLogoChoiceChange={onLogoChoiceChange}
                hasOwnLogo={hasOwnLogo}
                hasAgencyLogo={hasAgencyLogo}
                ownLogoUrl={ownLogoUrl}
                ownLogoSmallUrl={ownLogoSmallUrl}
                agencyLogoUrl={agencyLogoUrl}
                agencyLogoSmallUrl={agencyLogoSmallUrl}
                isPdfGenerating={isPdfGenerating}
            />

            {hasLogoSelected && (
                <>
                    <div className="flex items-center space-x-2 pt-2 border-t">
                        <Checkbox
                            id="include-pdf"
                            checked={includePdf}
                            onCheckedChange={onIncludePdfChange}
                        />
                        <Label
                            htmlFor="include-pdf"
                            className="text-sm font-medium cursor-pointer"
                        >
                            {t('itinerary.includePdf')}
                        </Label>
                    </div>

                    {includePdf && (
                        <PdfGenerator
                            isPdfGenerating={isPdfGenerating}
                            pdfBase64={pdfBase64}
                            pdfFilename={pdfFilename}
                            pdfError={pdfError}
                            onGeneratePdf={onGeneratePdf}
                            onPreviewPdf={onPreviewPdf}
                            generateDisabled={false}
                        />
                    )}
                </>
            )}
        </div>
    );
};
